export const httpUrl = {
    /* 
        base
    */

    Login : "/api/v1/auth/authenticate",
    Register : "/api/v1/auth/register",

    /*
        ROL API    
    */
    t1 : "/kr/lol/summoner/v4/summoners/by-name/",
    t2 : "/kr/lol/league/v4/entries/by-summoner/",
    t3 : "/asia/lol/match/v5/matches/by-puuid/",
    t4 : "/asia/lol/match/v5/matches/",
    
};

